import React, {useEffect} from 'react';
import {usePhaseState} from 'funnel-schedule/phase-context';
import ImmunitySalesIndex from './join';
import track from 'utils/track';

export default function () {
  useEffect(
    () =>
      track('Product Viewed', {
        product_id: 'B-IHC',
        sku: 'B-IHC',
        name: 'Immune Health Collection',
        variant: 'ihc21-special',
        value: 7,
        currency: 'usd'
      }),
    []
  );
  return <ImmunitySalesIndex ctaOverride="salesPrice" ctaNoTimer />;
}
